import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 21042 20020"
    {...props}
  >
    <defs>
      <style>
        {
          // ".str0{stroke:#000;stroke-width:601.194;stroke-linecap:round;stroke-linejoin:round}.fil0{fill:none}"
        }
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_2528237942528">
        <path
          d="M20741 1780c-5 20-10 45-15 65-220 1094-889 2107-1888 2968-610 522-1340 988-2164 1383-659 319-1384 588-2149 800-694 198-1428 345-2188 441-669 86-1359 132-2063 132-525 0-1040-26-1539-76-765-71-1499-198-2189-380-769-193-1494-451-2148-765-835-390-1564-861-2169-1403C1185 4018 520 2904 346 1688"
          className="fill-none stroke1"
          style={{
            strokeWidth: 601.194,
            strokeLinecap: "round",
          }}
        />
        <path
          d="M2414 1688c1224 2153 4292 3682 8139 3682 3848 0 7345-1529 8699-3682"
          className="fill-none stroke1"
          style={{
            strokeWidth: 601.194,
            strokeLinecap: "round",
          }}
        />
        <path
          d="M5312 1689c1019 1198 2893 1998 5241 1998 2339 0 4552-800 5741-1998M301 301h20441v1388H301zM345 1686v18033M2284 17182l-55-12237M4398 14578V6348M6546 11859V7113M8735 10881V7493M344 19717c543-266 1250 164 1719-419 555-692-336-1426 219-2118s1446 42 2002-650c555-693-335-1427 220-2120 556-693 1447 42 2003-651 556-694-335-1428 222-2122s1448 41 2004-653M20726 19719V1688M18838 4813l-50 12369M16674 14578V6196M14525 11859V6996M12337 10881V7437M20725 19717c-544-266-1250 164-1719-419-555-692 336-1426-219-2118s-1446 42-2002-650c-555-693 335-1427-220-2120-556-693-1447 42-2003-651-556-694 334-1428-222-2122-557-694-1448 41-2004-653"
          className="fill-none stroke1"
          style={{
            strokeWidth: 601.194,
            strokeLinecap: "round",
          }}
        />
      </g>
    </g>
  </svg>
);
export default SvgComponent;
